<template>
  <div id="nav">
    <div class="nav-imgs nav-left" @click="handleSelect(navList[0],0)">
      <img src="@/assets/logo.png">
      <img src="@/assets/logo-title.png">
    </div>
    <div class="nav-right">
      <ul>
        <li v-for="(item,index) in navList"
            :key="index"
            :class="{'active':navActiveIndex===index}"
            @click="handleSelect(item,index)"
        >
          {{item.label}}
        </li>
        <li>
          <el-dropdown :trigger="'hover'">
            <div class="li-dropdown">企业入驻</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goNewTabPage('join/demander')">委托商入驻</el-dropdown-item>
              <el-dropdown-item @click.native="goNewTabPage('join/service')">服务商入驻</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
      <div class="nav-buttons">
        <button @click="goOtherPage('https://web.zijinchangxiu.com/#/user/login')">登录</button>
        <button @click="goOtherPage('https://web.zijinchangxiu.com/#/user/register')">注册</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navActiveIndex: 0,
        navList: [
          {url:'/home',label: '首页'},
          {url:'/production',label: 'SaaS'},
          {url:'/solution',label: '售后服务'},
          {url:'/download',label: '下载'},
          // {url:'/help',label: '帮助中心'},
          {url:'/about',label: '关于我们'},
        ]
      };
    },
    created() {
      this.navActiveIndex = this.navList.findIndex(item=> item.url === this.$route.matched[1].path);
    },
    watch:{
      $route(to,from){
        this.navActiveIndex = this.navList.findIndex(item=> item.url === this.$route.matched[1].path);
      }
    },
    methods: {
      handleSelect(item,index) {
        if(this.navActiveIndex!==index)        // 避免重复跳转
          this.$router.push(item.url);
        this.navActiveIndex=index;
      },
      goOtherPage(url){
        console.log(url);
        window.open(url,'_blank')
      },
      goNewTabPage(url){
        window.open(window.location.origin + '/#/' +url,'_blank');
      }
    }
  }
</script>

<style lang="scss" scoped>
  #nav {
    position: fixed;
    top: 0;
    z-index: 10;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    background: white;
    justify-content: space-between;
    align-items: center;
    padding: 0 212px 0 126px;
    height: 75px;
    font-size: 16px;
    border-bottom: 1px solid #f4f4f4;
    .nav-left{
      &:hover{
        cursor: pointer;
      }
    }
    .nav-right{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      ul{
        list-style-type: none;
        float: left;
        height: 56px;
        min-width: 900px;
        margin: 0;
        li{
          float: left;
          width: 64px;
          height: 16px;
          font-size: 16px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #000000;
          line-height: 16px;
          padding: 20px 50px;
          &:hover{
            color: #ffbd50;
            cursor: pointer;
          }
          &.active{
            color: #ffbd50;
          }
        }
        .li-dropdown {
          float: left;
          width: 64px;
          height: 16px;
          font-size: 16px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #000000;
          line-height: 16px;
        }
      }
      .nav-buttons{
        display: inline-flex;
        min-width: 305px;
        button{
          width: 124px;
          height: 35px;
          border-radius: 18px;
          border: 1px solid;
          cursor: pointer;
          outline:none;
          &:first-child{
            color: #FF9F00;
            background: white;
            margin-right: 57px;
          }
          &:last-child{
            color: white;
            background: #FF9F00;
          }
        }
      }
    }
    .nav-imgs{
      width: 152px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
      img:first-child{
        width: 40px;
        height: 48px;
      }
      img:nth-child(2){
        width: 94px;
        height: 20px;
      }
    }
  }

  @media screen and (max-width: 1600px) {
    #nav{
      padding: 0 50px;
      .nav-right{
        ul{
          min-width: 760px;
          li {
            padding: 20px 30px;
          }
        }
        .nav-buttons{
          width: 155px;
          button{
            width: 100px;
            &:first-child{
              margin-right: 40px;
            }
          }
        }
      }
    }
  }
</style>
